<script>
	import { onMount } from 'svelte';
	import { getText } from '../../../../share/utils';
	
	let badge;
	let scrolledBefore = 0;
	let transform = () => {};
	
	function animateBadge() {
		// right Page of "Now" container. So actual displayed page:
		const rightContainer = document.querySelector('.container > .right');
		const scrolled = rightContainer ? rightContainer.scrollTop : 0;
		if(scrolledBefore !== scrolled) {
			transform = (factor) => {
				// kind of a custom calculation factor driven by window width:
				const windowFactor = Math.max(0.5, Math.min(1, window.innerWidth / 2560));
				return `translateY(${Math.max(-320, scrolled * factor * windowFactor)}px)`;
			}
		}
		scrolledBefore = scrolled;
		requestAnimationFrame(animateBadge);
	}
	function badgeInNowPage(element) {
		if(!element.parentElement) {
			return false;
		}
		return element.parentElement.classList.contains('now') || badgeInNowPage(element.parentElement);
	}
	
	onMount(() => {
		if(badgeInNowPage(badge)) {
			animateBadge();
		}
	})
</script>

<div class="page-opel marginbox">
	<div class="flex structure">
		<div class="flex row structure-3">
			<div class="flex element">
				<img loading="lazy" alt="Opel-Case-Study - Header" src="./../img/19.Opel_Case_Study/02.marktlaunch/OPEL-SK001_ComboME_WM_steht_kompakt_2_K_Header.webp">
			</div>
			
			<div class="flex element badge" bind:this={badge} style="transform: {transform(-0.25)}">
				<img loading="lazy" alt="Opel-Case-Study - Header" src="./../img/19.Opel_Case_Study/02.marktlaunch/Gruppe343.webp">
			</div>
		</div>
	</div>
	
	<div class="flex structure">
		<div class="flex col structure-1">
			<div class="flex element">
				<img loading="lazy" alt="Opel-Case-Study - elf Meter" src="./../img/19.Opel_Case_Study/02.marktlaunch/OPEL-SK001_ComboME_Phase1_elf-Meter-zum-Auto_K.webp">
			</div>
			
			<div class="flex element">
				<img loading="lazy" alt="Opel-Case-Study - Torwand"
					 src="./../img/19.Opel_Case_Study/02.marktlaunch/torwand.webp">
			</div>
		</div>
		
		<div class="flex col structure-2">
			<div class="flex element">
				<div class="text">
					<h2>{getText("19.02.01_h2")}</h2>
					<p class="caption">{getText("19.02.02_caption")}</p>
				</div>
			</div>
			
			<div class="flex element">
				<img loading="lazy" alt="Opel-Case-Study - Smileys" src="./../img/19.Opel_Case_Study/02.marktlaunch/OPEL-SK001_ComboME_Phase2_VONG_B_K.webp">
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	.img-single {
		margin: $spacing-mobile $spacing-mobile $media-gap $spacing-mobile;
	}
	
	.page-opel {
		h2 {
			margin-bottom: $media-gap;
		}
		
		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column wrap;
		}
		
		.element {
			min-width: 100px;
		}
		
		.commercial {
			position: relative;
			width: 100%;
			height: 100%;
		}
		
		.content {
			flex: 1 100%;
		}
		
		.structure {
			flex-flow: row wrap;
			gap: $media-gap;
		}
		
		.structure-1 {
			width: 100%;
			margin-bottom: $media-gap;
			padding: 0;
			
			@include for-tablet-portrait-up {
				flex: 1;
			}

			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;

				&:last-of-type {
					@include for-tablet-portrait-up {
						margin-bottom: 0;
					}
				}
			}
		}
		
		.structure-2 {
			width: 100%;
			padding: 0;
			
			@include for-tablet-portrait-up {
				flex: 1;
			}
			
			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;
			}
			
			> .element:first-of-type {
				@include for-tablet-portrait-up {
					padding-right: 5vw;
				}
				
				@include for-desktop-up {
					p.caption {
						padding-right: 6vw;
					}
				}
			}
		}


		.structure-1,
		.structure-2 {
			@include for-tablet-portrait-up {
				justify-content: space-between;
			}
		}
		
		.structure-3 {
			width: 100%;
			margin-bottom: $media-gap;
			padding: 0;
			position: relative;
			
			.element:first-of-type {
				height: fit-content;
				padding-right: 5vw;
			}
			
			.badge {
				width: 35%;
				height: fit-content;
				position: absolute;
				top: 0;
				right: -2rem;
			}
		}
		
		.text {
			margin: 0;
		}
	}
</style>
